import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import Helmet from 'react-helmet';
import SingleSignOnFailedForm from '../../containers/Login/SingleSignOnFailedForm';
import { setIsDedicatedWorkflow } from '../../redux/modules/workflow/workflow-action-creator';
import { links } from '../../shared/links';

class SingleSignOnFailedPage extends Component {
  UNSAFE_componentWillMount = () => {
    this.props.dispatch(setIsDedicatedWorkflow(false));
  }

  render() {
    const { formatMessage } = this.props.intl;
    return (
      <div>
        <Helmet
          htmlAttributes={{ lang: this.props.language || 'en' }}
          title={formatMessage(links.singleSignOnFailed) }
        >
        </Helmet>
        <SingleSignOnFailedForm />
      </div>
    );
  }
}

SingleSignOnFailedPage.propTypes = {
  intl: PropTypes.object,
  dispatch: PropTypes.func.isRequired,
  language: PropTypes.string,
};

const mapStateToProps = (state, ownProps) => ({
  language: state.language.languageCode,
  token: state.token,
  location: ownProps.location,
});

export default connect(mapStateToProps)(injectIntl(SingleSignOnFailedPage));